import { useEffect, useState } from 'react';

export function useCVParam() {
  const [isCVMode, setIsCVMode] = useState(false);
  const [phone, setPhone] = useState<string | null>(null);

  useEffect(() => {
    // Pulisci /CV dall'URL se presente (per UX - l'URL rimane pulito)
    const pathSegments = window.location.pathname.split('/');
    const hasCVInUrl = pathSegments.some(segment => segment.toUpperCase() === 'CV');
    if (hasCVInUrl) {
      const newPath = pathSegments.filter(segment => segment.toUpperCase() !== 'CV').join('/') || '/';
      window.history.replaceState({}, document.title, newPath);
    }

    // Verifica CV mode dal server (cookie httpOnly verificato server-side)
    fetch('/api/cv/data')
      .then(r => r.json())
      .then(data => {
        if (data.active) {
          setIsCVMode(true);
          setPhone(data.phone);
        }
      })
      .catch(() => {});
  }, []);

  return { isCVMode, phone };
}
